import * as React from "react";
const SvgArrow = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2 2L10 8L18 2", stroke: "#6A6B8A", strokeWidth: 4, strokeLinecap: "round" }));
export default SvgArrow;
